(() => {
  const start = () => {
    const feedback = document.querySelector('.hd-form-feedback[role="alert"], .hd-form-feedback[role="status"]');
    if (feedback) feedback.focus();

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('details.site-nav__details[open]');
      if (!menu) return;
      menu.querySelector('summary').focus();
      menu.open = false;
      menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
